const login = {
        // view structure
        title: String("Inicio de sesión"),
        welcomeMsg: String("Bienvenido a AgroUPAdvisor!"),
        credentialAsk: String("Introduzca sus credenciales"),
        rememberMe: String("Recordar mis credenciales"),
        signInButton: String("Iniciar Sesión"),
        forgotPass: String("Has olvidado tu contraseña?"),
        createNewAccount: String("Crear cuenta nueva"),
        resendEmail: String("Re-enviar email de verificación"),
        forgotPassTitle: String("Has olvidado tu contraseña?"),
        forgotPassDescription: String("Introduce tu correo electronico y se te enviará un correo para que puedas restablecer tu contraseña."),
        forgotPassButton: String("Enviar Correo"),
        cancelButton: String("Cerrar"),
        emailAlreadySent: String("Se ha enviado un correo electrónico con instrucciones para recuperar la contraseña."),
        
        // fields
        username: String("Nombre de usuario"),
        password: String("Contraseña"),
        email: String("Dirección de correo electrónico"),

        // Errors
        errorFieldRequired: String("Este campo es obligatorio"),
        errorInvalidLength: String("Número de caracteres mínimo: "),
        errorCredentials: String("El usuario y/o contraseña son incorrectos."),
        errorFieldEmail: String("Dirección de correo invalida."),
        adviceActiveAccount:"Esta cuenta todavía no ha sido activada.",
        emailNotRegistered: String("La dirección de email no esta asociada a ningún usuario."),
};

export default login;